<template>
  <div>
    <el-form :model="ruleForm" :rules="rules" ref="ruleForm" @submit.native.prevent class="demo-ruleForm">
      <!-- 手机号 -->
      <el-form-item label="" prop="admin">
        <div class="inputtx mt0">
          <el-input
            prefix-icon="iconfont icon-shoujihao"
            @focus="inputFocus = 'admin'"
            placeholder="请输入手机号"
            @blur="inputFocus = ''"
            type="text"
            v-model="ruleForm.admin"
            autocomplete="off"
            clearable
          ></el-input>
        </div>
      </el-form-item>
      <!-- 验证码 -->
      <el-form-item label="" prop="yzm">
        <div class="inputtx">
          <el-input clearable placeholder="请输入图片验证码" v-model="ruleForm.yzm" autocomplete="off">
            <template slot="append"> <img @click="updataImgCode" :src="imgCodeUrl" style="height: 40px; display: block; width: 150px; margin-right: 0" /></template>
          </el-input>
        </div>
      </el-form-item>
      <!-- 手机验证码 -->
      <el-form-item label="" prop="pwd">
        <div class="inputtx inputtxre">
          <el-input
            clearable
            prefix-icon="iconfont icon-yanzhengma"
            @focus="inputFocus = 'pwd'"
            placeholder="请输入手机验证码"
            @blur="inputFocus = ''"
            v-model="ruleForm.pwd"
            autocomplete="off"
          ></el-input>
          <p @click="getphoneCode"><span v-if="phonems != '获取验证码'">已发送</span>{{ phonems }}</p>
        </div>
      </el-form-item>
      <el-form-item class="submit_btn">
        <el-button type="primary" native-type="submit" @click="submitForm('ruleForm')" :loading="isBtnLoading">登录</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
import { mapActions, mapGetters, mapMutations } from "vuex";
export default {
  data() {
    // 手机号验证
    var checkMobile = (rule, value, cb) => {
      const regMobile = /^(0|86|17951)?(13[0-9]|14[0-9]|15[0-9]|16[0-9]|17[0-9]|18[0-9]|19[0-9])[0-9]{8}$/;

      if (regMobile.test(value)) {
        return cb();
      }
      cb(new Error("请输入合法的手机号"));
    };
    return {
      isBtnLoading: false,
      imgCodeUrl: "",
      inputFocus: false,
      ruleForm: {
        admin: "",
        pwd: "",
        yzm: "",
      },
      code: "",
      phonems: "获取验证码",
      rules: {
        admin: [
          { required: true, message: "请输入手机号", trigger: "blur" },
          { validator: checkMobile, trigger: "blur" },
        ],
        pwd: [{ required: true, message: "请输入手机验证码", trigger: "blur" }],
        yzm: [{ required: true, message: "请输入图片验证码", trigger: "blur" }],
      },
    };
  },
  created() {
    this.getLoginImgCode()
      .then((res) => {
        // console.log(res);
        this.imgCodeUrl = res.data.img;
      })
      .catch((err) => {
        console.log(err);
      });
  },
  mounted() {
    // this.getLoginCode().then((res) => {
    //   if (res.code == 1) {
    //     this.code = res.data.codes;
    //   }
    // });
  },
  methods: {
    ...mapMutations({
      setUserInfo: "setUserInfo", //设置用户信息
      setToken: "setToken", //设置token
      setTokenTime: "setTokenTime", //设置token过期时间
      setLogin: "setLogin", //设置登陆状态
      setIsAllinUser: "setIsAllinUser", //设置是否注册通联
    }),
    ...mapActions({
      getLoginImgCode: "loginModule/getLoginImgCode",
      getMCode: "loginModule/getMCode",
      // checkCode: "loginModule/checkCode",
      postCheckImg: "loginModule/postCheckImg",
      verificationLogin: "loginModule/verificationLogin",
      getPhoneCode:"loginModule/getPhoneCode"
    }),
    //手机号校验
    validatorPhone(val) {
      return /^1[3456789]\d{9}$/.test(val);
    },
    getphoneCode() {
      if (this.ruleForm.admin == "" || this.ruleForm.admin == null || !this.validatorPhone(this.ruleForm.admin)) {
        this.$message({
          message: "请先输入正确格式的手机号！",
          type: "warning",
        });
        return;
      }
      if (this.phonems != "获取验证码") return;
      if (this.ruleForm.yzm == "" || this.ruleForm.yzm == null) {
        this.$message({
          message: "请先输入图片验证码进行验证！",
          type: "warning",
        });
        return;
      }
      let opt = {
        cellphones: this.ruleForm.admin,
        // type: "login", //此参数只在短信登录时传
        // port: "merchant", //登录端标识，商家端-merchant，系统端-admin，H5定制-merchant_made
      };
      
      let times = new Date().getTime();
      let singt = `123456,h5,${returnCitySN["cip"]},,${times},JSU$E&H@F`;
      let md5Params=this.$md5(singt);
      this.getPhoneCode({
        MobilePhone: this.ruleForm.admin.toString(),
        Ip: returnCitySN["cip"],
        Phone: "",
        Time: times,
        DeviceType: "h5",
        Code: "123456",
        sign: md5Params,
        Msg: "信富生活{0}",
      }).then((res) => {
        if (res.code == 0) {
          localStorage.setItem("Beitoken",res.data.data.Authorization_token)
          this.$message({
            message: "发送成功！",
            type: "success",
          });
        } else {
          this.$message.error(res.message);
        }
      });
      // this.getMCode(opt)
      //   .then((res) => {
      //     // console.log(res)
      //     if (res.data.code === 1) {
      //       this.$message({
      //         message: "已发送手机短信验证码",
      //         type: "success",
      //       });
      //     } else {
      //       this.$message({
      //         message: res.data.msg,
      //         type: "warning",
      //       });
      //     }
      //   })
      //   .catch((err) => {
      //     console.log(err);
      //   });
      let counts = 60;
      let time = setInterval(() => {
        let str = "";
        if (counts > 0) {
          counts--;
          str = counts + "s";
          //   this.disabled=true;
        } else {
          str = "获取验证码";
          //   this.disabled=false;
          clearInterval(time);
        }

        this.phonems = str;
      }, 1000);
    },
    submitForm(formName) {
      //提交表单
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.isBtnLoading = true;
          this.postCheckImg({ codes: this.ruleForm.yzm })
            .then((res) => {
              // console.log(res);
              if (res.data.code === 1) {
                let opt = {
                  cellphones: this.ruleForm.admin,
                  codes: this.ruleForm.pwd,
                  port: "merchant", //登录端标识，商家后台写死为merchant，系统后台写死为admin
                };
                this.verificationLogin(opt)
                  .then((res) => {
                    // console.log("手机登录", res);
                    if (res.data.code === 1) {
                      if (res.data.data.reviewer_status == undefined) {
                        res.data.data.reviewer_status = "1";
                      }
                      switch (res.data.data.reviewer_status) {
                        case "0":
                          this.$message.warning(res.data.data.msg);
                          if (res.data.msg == "审核中" || res.data.msg == "审核未通过") {
                            this.$router.push({
                              path: "/regist",
                              query: {
                                phone: this.ruleForm.admin,
                              },
                            });
                          }
                          break;
                        case "1":
                          this.$message.success("登录成功");
                          this.setLogin(true);
                          this.setToken(res.data.data.token);
                          this.setIsAllinUser(res.data.data.is_allin_user);
                          this.$setSessionStorage("token", res.data.data.token);
                          localStorage.setItem("Beitoken", res.data.data.Authorization_token)
                          this.$setSessionStorage("userid", res.data.data.id);
                          this.$setSessionStorage("merchant_role_id", res.data.data.merchant_role_id);
                          console.log(res.data.data.merchant_role_id,'res.data.data.merchant_role_id')
                          // this.setTokenTime(res.data.userinfo.et);
                          // this.setUserInfo(res.data);
                          this.$router.push("/home");
                          break;
                        case "2":
                          if (res.data.msg == "审核中" || res.data.msg == "审核未通过") {
                            this.$router.push({
                              path: "/regist",
                              query: {
                                phone: this.ruleForm.admin,
                              },
                            });
                          }

                          break;
                      }
                    } else {
                      this.$message({
                        message: res.data.msg,
                        type: "error",
                      });
                      if (res.data.msg == "审核中" || res.data.msg == "审核未通过") {
                        this.$router.push({
                          path: "/regist",
                          query: {
                            phone: this.ruleForm.admin,
                          },
                        });
                      }
                    }
                    this.updataImgCode();
                    this.isBtnLoading = false;
                  })
                  .catch((err) => {
                    console.log(err);
                  });
              } else {
                this.$message({
                  message: "验证码错误",
                  type: "error",
                });
                this.isBtnLoading = false;
              }
            })
            .catch((err) => {
              console.log(err);
            });
          //#region
          // let opt = {
          //   cellphones: this.ruleForm.admin,
          //   codes: this.ruleForm.pwd,
          //   logintypes: 1,
          //   codes: this.code,
          // };
          // this.loginUser(opt).then((res) => {
          //   console.log(res);
          //   if (res.code == 1) {
          //     this.$message({
          //       message: "登陆成功",
          //       type: "success",
          //     });
          //     this.setLogin(true);
          //     this.setToken(res.data.tokens);
          //     // this.setTokenTime(res.data.userinfo.et);
          //     // this.setUserInfo(res.data);
          //     // this.getuserInfo({ tokens: res.data.tokens }).then((ress) => {
          //     //   console.log("user", ress);
          //     //   if (ress.code == 1) {
          //     //     this.setUserInfo(ress.data.list[0]);
          //     //   }
          //     // });
          //     this.$router.push("/home");
          //   } else {
          //     this.$message.error(res.msg);
          //   }
          // });
          //#endregion
        } else {
          //校验规则不通过
          return false;
        }
      });
    },
    updataImgCode() {
      this.getLoginImgCode()
        .then((res) => {
          // console.log(res);
          this.imgCodeUrl = res.data.img;
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
};
</script>
<style lang="scss" scoped>
.inputtxre {
  position: relative;
  p {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    right: 32px;
    color: #f8f8f8;
    font-size: 14px;
    cursor: pointer;
    span {
      margin-right: 5px;
    }
  }
}
.logo {
  width: 69px;
  height: 69px;
  border-radius: 10px;
  overflow: hidden;
  margin: 16px auto;
  background: #d8d8d8;
}
::v-deep .el-input-group__append {
  padding: 0;
  border: none;
  background: #fff;
}

::v-deep .el-input__inner {
  background: rgba(8, 63, 75, 0.2);
  color: #fff;
  line-height: 40px !important;
  height: 40px !important;
}
::v-deep .el-input {
  background: rgba(8, 63, 75, 0.2);
  line-height: 40px !important;
  height: 40px !important;
}
.mt0.inputtx {
  margin-top: 14px;
}

.inputtx {
  display: flex;
  align-items: center;
  background: transparent;
  border: 1px solid rgba(14, 72, 120);
  border-radius: 6px;
  overflow: hidden;
  margin-top: 28px;
  img {
    width: 16px;
    height: 16px;
    margin-left: 16px;
    cursor: pointer;
  }
}
::v-deep .el-input__inner {
  border: none;
}
::v-deep .el-form-item__error {
  left: 4%;
}
::v-deep .el-form-item {
  margin: 0;
}
.login {
  .login_form {
    width: 26%;
    background: #ffffff;
    // box-shadow: 0px 18px 29px 0px rgba(0, 46, 142, 0.44);
    border-radius: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    right: 22%;
    padding: 27px 50px 18px;
    .login_box {
      // height: 260px;
      // padding: 0 50px;
      // background-color: rgba(255, 255, 255, 1);
      // box-shadow: 0px 0px 10px 0px rgba(139, 140, 140, 0.3);
      // border-radius: 2px;
      width: 100%;
      .login_top {
        width: 100%;
        text-align: center;
        height: 20px;
        line-height: 20px;
        margin-bottom: 82px;
        font-size: 24px;
        color: #333333;
        cursor: pointer;
        font-weight: 500;
      }
      .login_bottom {
        .submit_btn {
          margin-top: 32px;
          ::v-deep .el-form-item__content {
            text-align: center;
          }
          ::v-deep .el-button {
            width: 100%;
            font-size: 16px;
            padding: 13px 0;
            border-radius: 6px;
          }
          ::v-deep .el-button--primary {
            background-color: #1cc5e3;
            border-color: #1cc5e3;
          }
        }
      }
    }
    .login_img {
      img {
        height: auto;
      }
      img {
        position: absolute;
        top: 0;
        left: 50%;
        z-index: 1;
        width: 10rem;
      }
      .normal {
        transform: translate(-50%, -83%);
      }
      .greeting {
        transform: translate(-50%, -75.8%);
      }
      .blindfold {
        width: 8.6rem;
        transform: translate(-50%, -75%);
      }
    }
  }
}

::v-deep .el-message-box__btns {
  button {
    width: 80px !important;
  }
}
</style>